class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
    this.addEventListener('submit', this.handleCheckoutSubmit.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const el = document.getElementById(section.id);
      if (!el || !parsedState.sections[section.id]) return;
      el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-notification-fsbar',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  async handleCheckoutSubmit(evt) {
    if (!evt.target || evt.target.id !== 'cart-notification-form') return;

    evt.preventDefault();

    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();

      if (this.cartRequiresDesignApproval(cart)) {
        window.location.href = this.cartUrl;
        return;
      }

      this.submitCheckoutForm(evt.target);
    } catch (error) {
      console.warn('[koebi-cart] Checkout-Gate konnte den Cart nicht prüfen:', error);
      window.location.href = this.cartUrl;
    }
  }

  cartRequiresDesignApproval(cart) {
    return !!cart?.items?.some((item) => {
      const handle = String(item.handle || item.product_handle || '').toLowerCase();
      if (handle === 'custom-etikett') return true;

      const properties = item.properties || {};
      return Object.keys(properties).some((key) => key.includes('Druckdatei'));
    });
  }

  submitCheckoutForm(form) {
    let checkoutInput = form.querySelector('input[name="checkout"][data-koebi-checkout-submit]');
    if (!checkoutInput) {
      checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = '1';
      checkoutInput.dataset.koebiCheckoutSubmit = 'true';
      form.appendChild(checkoutInput);
    }

    form.submit();
  }

  get cartUrl() {
    return window.routes?.cart_url || '/cart';
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
